/** Branding and default document metadata for the admin app */
export const APP_NAME = 'Taxi Admin';
export const APP_TAGLINE = 'Manage bookings, drivers, pricing, and operations';
export const APP_DESCRIPTION =
  'Taxi Admin — operations dashboard for bookings, fleet, pricing, availability, and customer support.';

export function formatPageTitle(pageName: string): string {
  return `${pageName} | ${APP_NAME}`;
}

export function formatPageDescription(pageName: string, detail?: string): string {
  if (detail?.trim()) return detail.trim();
  return `${pageName} — ${APP_TAGLINE}`;
}
